import { lazy, Suspense, useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";

// Admin is the Home Screen app's start route. Keep it in the main bundle so
// iOS does not need a second lazy chunk before it can paint the first screen.
import Admin from "./page/admin";

const SearchPage = lazy(() => import("./page/Search"));
const Login = lazy(() => import("./page/login"));
const SearchShopeePage = lazy(() => import("./component/SearchShopee"));
const InfoProduct = lazy(() => import("./page/infoProduct"));
const OrderList = lazy(() => import("./page/orderList"));
const PinRequestList = lazy(() => import("./page/pinRequestList"));
const SendPinPage = lazy(() => import("./page/sendPin"));
const PinDisneyList = lazy(() => import("./page/pinDisneyList"));
const HomePage = lazy(() => import("./page/homePage"));
const AppManageList = lazy(() => import("./page/appManage"));
const HelpPage = lazy(() => import("./page/help"));
const HelpDetailPage = lazy(() => import("./page/helpDetail"));
const HelpManageList = lazy(() => import("./page/helpManage"));
const DisneyGuidePage = lazy(() => import("./page/DisneyGuide"));

function RouteLoading() {
  useEffect(() => {
    const recoveryId = window.setTimeout(() => {
      window.__cinemaRecover?.("route-load-timeout", false);
    }, 15000);

    return () => window.clearTimeout(recoveryId);
  }, []);

  return (
    <div className="route-loading" role="status" aria-live="polite">
      <img src="/icon.jpg" alt="" className="route-loading-logo" />
      <span className="route-loading-spinner" aria-hidden="true" />
      <strong>กำลังโหลดหน้า...</strong>
      <span>หากโหลดไม่สำเร็จ ระบบจะกู้คืนให้อัตโนมัติ</span>
    </div>
  );
}

function App() {
  useEffect(() => {
    window.__cinemaMarkAppMounted?.();
  }, []);

  return (
    <>
      <Suspense fallback={<RouteLoading />}>
      <Routes>
        <Route
          path="/searchOrder"
          element={
            <div className="App">
              <header className="App-header">
                <SearchShopeePage />
              </header>
            </div>
          }
        />
        <Route path="/" element={<HomePage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/help/:id" element={<HelpDetailPage />} />
        <Route path="/disney-guide" element={<DisneyGuidePage />} />
        <Route path="/disney" element={<SearchPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/appManage" element={<AppManageList />} />
        <Route path="/helpManage" element={<HelpManageList />} />
        <Route path="/order" element={<OrderList />} />
        <Route path="/pin" element={<PinRequestList />} />
        <Route path="/pinDisney" element={<PinDisneyList />} />
        <Route path="/sendPin" element={<SendPinPage />} />
        <Route path="/admin/product/:id" element={<InfoProduct />} />
      </Routes>
      </Suspense>
    </>
  );
}

export default App;
